import { create } from 'zustand'

interface SymbolMapState {
  symbolMap: Record<string, MarketSymbolItem>
  setSymbolMap: (markets: MarketSymbolItem[]) => void
}

export const useSymbolMapStore = create<SymbolMapState>()(set => ({
  symbolMap: {},
  setSymbolMap: (markets) => {
    const map: Record<string, MarketSymbolItem> = {}
    for (const item of markets) {
      map[item.symbol] = item
    }
    set({ symbolMap: map })
  },
}))
